import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    icon: {
        width: 100,
        height: 100,
        fill: theme.palette.primary.main,
        marginBottom: theme.spacing(2),
    }
}))